<template>
	<v-card elevation="0" class="top-divider py-2">
		<v-row no-gutters align-content="center" align="center">
			<div class="handle">
				<v-icon>mdi-drag</v-icon>
			</div>
			<v-toolbar-title class="text-body-1 pl-0">
				{{ ledgerColumn.order_number + 1 }}列目
				<template v-if="!showForm">
					{{ ledgerColumn.name }}
				</template>
			</v-toolbar-title>
			<v-row no-gutters justify="end">
				<v-menu offset-y close-on-click>
					<template v-slot:activator="{ on, attrs }">
						<v-btn text color="red" v-bind="attrs" v-on="on" dense> 削除 </v-btn>
					</template>

					<v-list>
						<v-list-item @click="$emit('delete-ledger-column')">
							<v-list-item-title color="red" class="text-body-2">本当に削除する</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<v-btn icon color="primary" @click="showForm = !showForm">
					<v-icon color="secondary" v-if="!showForm">mdi-chevron-down</v-icon>
					<v-icon color="secondary" v-else-if="showForm">mdi-chevron-up</v-icon>
				</v-btn>
			</v-row>
		</v-row>
		<div v-show="showForm">
			<v-text-field
				v-model="ledgerColumn.name"
				label="列の名前(必須)"
				class="mt-4"
				type="text"
				:rules="[rules.required]"
				required
				dense
				outlined
				@blur="changeLedgerColumn"
			/>

			<v-select
				v-if="modelNames.length"
				v-model="ledgerColumn.base_model"
				label="参照データ"
				:items="modelNames"
				class="mt-4"
				item-text="name"
				item-value="id"
				:persistent-hint="!ledgerColumn.base_model"
				hint="選択しなければ台帳の参照データの項目から項目名を選択できます。"
				clearable
				dense
				outlined
				@change="setColumnNames"
			/>
			<v-select
				v-model="ledgerColumn.column_name"
				label="項目名(必須)"
				:items="columnNameOptions"
				class="mt-4"
				item-text="name"
				item-value="id"
				:rules="[rules.required]"
				required
				dense
				outlined
				@change="changeColumnName"
			/>
			<v-checkbox
				class="mt-0"
				v-model="ledgerColumn.editable_flag"
				label="台帳から直接データ編集を可能にする"
				:disabled="!isEditable"
				:hint="!isEditable ? '計算式や特別タイプを使用している場合は直接編集はできません。' : null"
			/>
			<h6>計算式を設定</h6>
			<v-radio-group v-model="showSection" row @change="changeSection">
				<v-radio label="使用しない" :value="null" />
				<v-radio
					v-for="option in showSectionOptions"
					:key="option.value"
					:label="option.label"
					:value="option.value"
				/>
			</v-radio-group>
			<div v-if="showSection == 'prefix'">
				<h6 class="text-body-2">計算式</h6>
				<div class="mt-2">
					<v-chip>
						{{ ledgerColumn.prefix_number ? ledgerColumn.prefix_number : "数値を入力してください" }}
					</v-chip>
					<v-chip>
						{{ formulaSymbol(ledgerColumn.prefix_formula) }}
					</v-chip>
					<v-chip>
						{{ ledgerColumn.column_name ? columnName : "項目名を選択してください" }}
					</v-chip>
				</div>
				<v-text-field
					v-model="ledgerColumn.prefix_number"
					label="数値(必須)"
					type="text"
					class="mt-4"
					:rules="showSection == 'prefix' ? [rules.required, rules.floatWithNegative] : []"
					dense
					outlined
					@change="changeLedgerColumn"
				/>
				<v-select
					v-model="ledgerColumn.prefix_formula"
					label="計算式(必須)"
					:items="columnOptions.formulas"
					item-text="name"
					item-value="id"
					class="mt-4"
					:rules="showSection == 'prefix' ? [rules.required] : []"
					dense
					outlined
					@change="changeLedgerColumn"
				/>
			</div>
			<div v-else-if="showSection == 'suffix'">
				<h6 class="text-body-2">計算式</h6>
				<div class="mt-2">
					<v-chip>
						{{ ledgerColumn.column_name ? columnName : "項目名を選択してください" }}
					</v-chip>
					<v-chip>
						{{ formulaSymbol(ledgerColumn.suffix_formula) }}
					</v-chip>
					<v-chip>
						{{ ledgerColumn.suffix_number ? ledgerColumn.suffix_number : "数値を入力してください" }}
					</v-chip>
				</div>
				<v-text-field
					v-model="ledgerColumn.suffix_number"
					label="数値(必須)"
					type="text"
					class="mt-4"
					:rules="showSection == 'suffix' ? [rules.required, rules.floatWithNegative] : []"
					dense
					outlined
					@change="changeLedgerColumn"
				/>
				<v-select
					v-model="ledgerColumn.suffix_formula"
					label="計算式(必須)"
					:items="columnOptions.formulas"
					item-text="name"
					item-value="id"
					class="mt-4"
					:rules="showSection == 'suffix' ? [rules.required] : []"
					dense
					outlined
					@change="changeLedgerColumn"
				/>
			</div>
			<div v-else-if="showSection == 'special'">特別</div>
		</div>
	</v-card>
</template>
<script>
import rules from "../../../helper/rules"

export default {
	props: {
		ledgerColumnData: Object,
		columnOptions: Object,
		originalModelColumns: Array,
		associationNames: Array,
	},
	data() {
		return {
			ledgerColumn: {
				uuid: null,
				name: null,
				order_number: null,
				base_model: null,
				column_name: null,
				column_type: null,
				meta_tag_id: null,
				editable_flag: null,
				prefix_formula: null,
				prefix_number: null,
				suffix_formula: null,
				suffix_number: null,
				special_type: null,
				special_string: null,
			},
			rules: rules,
			showForm: true,
			selectedModel: null,
			showSection: null,
			showSectionOptions: [
				{ label: "計算(前)", value: "prefix" },
				{ label: "計算(後ろ)", value: "suffix" },
				// { label: "特殊タイプ", value: "special" },
			],
		}
	},
	mounted() {
		this.ledgerColumn = this.ledgerColumnData
		if (this.ledgerColumn.suffix_formula && this.ledgerColumn.suffix_number) {
			this.showSection = "suffix"
		} else if (this.ledgerColumn.prefix_formula && this.ledgerColumn.prefix_number) {
			this.showSection = "prefix"
		} else if (this.ledgerColumn.special_type && this.ledgerColumn.special_string) {
			this.showSection = "special"
		}
	},
	methods: {
		setColumnNames() {
			this.ledgerColumn.meta_tag_id = null
			this.ledgerColumn.column_type = null
			this.ledgerColumn.column_name = null
			this.selectedModel = this.associationNames.find(
				(model) => this.ledgerColumn.base_model == model.id
			)
			this.changeLedgerColumn()
		},
		changeColumnName() {
			this.ledgerColumn.meta_tag_id = null
			this.ledgerColumn.column_type = null
			const selectedColumnName = this.columnNameOptions.find(
				(c) => c.id == this.ledgerColumn.column_name
			)
			if (selectedColumnName.meta_tag) {
				this.ledgerColumn.meta_tag_id = Number(selectedColumnName.id)
			}
			this.ledgerColumn.column_type = selectedColumnName.type

			this.changeLedgerColumn()
		},
		changeSection() {
			if (this.showSection == "prefix") {
				this.ledgerColumn.editable_flag = false
				this.ledgerColumn.suffix_formula = null
				this.ledgerColumn.suffix_number = null
				this.ledgerColumn.special_type = null
				this.ledgerColumn.special_string = null
			} else if (this.showSection == "suffix") {
				this.ledgerColumn.editable_flag = false
				this.ledgerColumn.prefix_formula = null
				this.ledgerColumn.prefix_number = null
				this.ledgerColumn.special_type = null
				this.ledgerColumn.special_string = null
			} else if (this.showSection == "special") {
				this.ledgerColumn.editable_flag = false
				this.ledgerColumn.prefix_formula = null
				this.ledgerColumn.prefix_number = null
				this.ledgerColumn.suffix_formula = null
				this.ledgerColumn.suffix_number = null
			} else {
				this.ledgerColumn.prefix_formula = null
				this.ledgerColumn.prefix_number = null
				this.ledgerColumn.suffix_formula = null
				this.ledgerColumn.suffix_number = null
				this.ledgerColumn.special_type = null
				this.ledgerColumn.special_string = null
			}
			this.changeLedgerColumn()
		},
		changeLedgerColumn() {
			this.$emit("change-ledger-column", this.ledgerColumn)
		},
	},
	computed: {
		isEditable() {
			return !this.showSection
		},
		modelNames() {
			return this.associationNames.filter((model) => model.association_type != "has_many")
		},
		columnNameOptions() {
			if (this.selectedModel) {
				return this.selectedModel.columns
			} else {
				return this.originalModelColumns
			}
		},
		formulaSymbol() {
			return (formula) => {
				if (!formula) return "計算式を選択してください"
				const selectedFormula = this.columnOptions.formulas.find((f) => f.id == formula)
				if (selectedFormula) {
					return selectedFormula.name
				} else {
					return null
				}
			}
		},
		columnName() {
			const selectedColumnName = this.columnNameOptions.find(
				(c) => c.id == this.ledgerColumn.column_name
			)
			if (!selectedColumnName) return null
			const type = selectedColumnName.type
			if ((type == "integer" || type == "float") && !selectedColumnName.options.length) {
				return selectedColumnName.name
			} else {
				return "項目は数値ではない可能性があります。"
			}
		},
	},
	watch: {
		ledgerColumnData(newValue, oldValue) {
			this.ledgerColumn = newValue
		},
		deep: true,
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/shared/color.scss";

.v-toolbar__content {
	padding: 0;
}
</style>